export const DETAIL_VIEW_PADDING_LEFT = 112;
